import React, { useState, useContext } from "react";
import { Context } from "../contexts/siteContext.js";
import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../../offline/storageService/offlineService";

export const SCContext = React.createContext(null);

export const SafetyCoachingContext = props => {
    const offlineService = new OfflineService();
    const { defaultSite } = useContext(Context);
    const [employees, setEmployees] = useState([]);
    const [supervisors, setSupervisors] = useState([]);
    let TeamCoachId = 0;
    if (defaultSite?.IntegratedSystem?.TeamCoachId !== null)
        TeamCoachId = parseInt(defaultSite?.IntegratedSystem?.TeamCoachId);

    const getEmployees = () => {
        if (TeamCoachId > 0) {
            HttpService.post("/TeamCoach/GetApiSupervisorOrEmployeeSelect", {
                ApiType: "Employee", TeamCoachID: TeamCoachId.toString()
            })
                .then(async (result) => {
                    if (result && result.offline) {
                        //get offline data
                        const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "Employees");
                        result = offlineResult.OfflineData;
                    }
                    setEmployees(result.data);
                },
                    (error) => {
                        console.log(error);
                    }
                )
        }
    };

    const getSupervisors = () => {
        if (TeamCoachId > 0) {
            HttpService.post("/TeamCoach/GetApiSupervisorOrEmployeeSelect", {
                ApiType: "Supervisor", TeamCoachId: TeamCoachId.toString()
            })
                .then(async (result) => {
                    if (result && result.offline) {
                        //get offline data
                        const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "Supervisors");
                        result = offlineResult.OfflineData;
                    }
                    setSupervisors(result.data);
                },
                    (error) => {
                        console.log(error);
                    }
                )
        }
    };

    const contextValue = {
        employees, supervisors, getEmployees, getSupervisors
    };

    return (
        <SCContext.Provider value={contextValue}>{props.children}</SCContext.Provider>
    );
};
